import { useTranslation } from "react-i18next";
import type { AssignmentViewMode } from "@services/types/session-assignation";
import SegmentedControl from "@shared/ui/segmented-control";

interface AssignmentViewSwitchProps {
  id?: string;
  value: AssignmentViewMode;
  disabled?: boolean;
  onChange: (value: AssignmentViewMode) => void;
}

const AssignmentViewSwitch = ({ id, value, disabled, onChange }: AssignmentViewSwitchProps) => {
  const { t } = useTranslation();
  return (
    <SegmentedControl<AssignmentViewMode>
      id={id}
      aria-label={t("assignation-edit.session-view.view-label")}
      value={value}
      disabled={disabled}
      onChange={onChange}
      options={(["traditional", "sessions"] as const).map(view => ({
        value: view,
        label: t(`assignation-edit.session-view.views.${view}`),
      }))}
    />
  );
};

export default AssignmentViewSwitch;
